
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"48","height":"48"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M33.6 0A14.191 14.191 0 0024 3.712 14.191 14.191 0 0014.4 0 14.422 14.422 0 000 14.4c0 17.882 21.747 32.576 22.669 33.2A2.383 2.383 0 0024 48a2.342 2.342 0 001.318-.4C26.24 46.986 48 32.406 48 14.4A14.422 14.422 0 0033.6 0zM24 42.65C20.608 40.141 11.622 32.896 7.245 24h3.187a2.4 2.4 0 002.214-1.485l2.086-5.069L21.9 29.99a2.382 2.382 0 002.086 1.2h.064a2.416 2.416 0 002.086-1.331l5.709-11.418L36.7 23.3a2.413 2.413 0 001.7.7h2.368C36.416 32.934 27.4 40.154 24 42.65zM42.573 19.2H39.4l-6.5-6.5a2.435 2.435 0 00-2.086-.678 2.4 2.4 0 00-1.766 1.293l-5.2 10.394L16.474 10.8a2.4 2.4 0 00-4.3.282L8.819 19.2H5.44a19.014 19.014 0 01-.64-4.8 9.568 9.568 0 0117.28-5.7 2.491 2.491 0 003.853 0 9.5 9.5 0 017.68-3.9 9.6 9.6 0 019.6 9.6 20.25 20.25 0 01-.64 4.8z","fill":"#fff"}})])
          )
        }
      }
    